import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import pl from "./locales/pl.json";

const namespacedResources = import.meta.glob("./locales/*.*.json", {
  eager: true,
  import: "default",
}) as Record<string, Record<string, unknown>>;
const resources: Record<string, Record<string, any>> = {
  en: { translation: en },
  pl: { translation: pl },
};
for (const [path, value] of Object.entries(namespacedResources)) {
  const match = path.match(/\/([^/.]+)\.(en|pl)\.json$/);
  if (match) resources[match[2]][match[1]] = value;
}
function initialLanguage() {
  try {
    const stored = localStorage.getItem("clp-app-language");
    if (stored === "en" || stored === "pl") return stored;
  } catch {
    /* Storage can be unavailable in private/embedded contexts. */
  }
  return typeof navigator !== "undefined" && navigator.language.startsWith("pl")
    ? "pl"
    : "en";
}
void i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage(),
    fallbackLng: "en",
    defaultNS: "translation",
    interpolation: { escapeValue: false },
  });
i18n.on("languageChanged", (language) => {
  try {
    localStorage.setItem("clp-app-language", language);
  } catch {
    /* Interface remains usable without storage. */
  }
  if (typeof document !== "undefined") document.documentElement.lang = language;
});
if (typeof document !== "undefined")
  document.documentElement.lang = i18n.language;
export default i18n;
